import { faChevronDown, faLocationDot } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import ClickAwayListener from 'components/CreateBooking/UI/ClickAwayListener';
import { FunctionComponent, useState } from 'react';
import styles from './LocationSelector.module.scss';

export interface BookingLocationOption {
    id: number;
    name: string;
}

interface LocationSelectorProps {
    options: Array<BookingLocationOption>;
    value?: number;
    disabled?: boolean;
    onChange: (marketplaceId: number) => void;
}

export const LocationSelector: FunctionComponent<LocationSelectorProps> = ({ options, value, disabled, onChange }) => {
    const [open, setOpen] = useState(false);
    const selected = options.find(option => option.id === value);

    const selectHandler = (marketplaceId: number) => {
        onChange(marketplaceId);
        setOpen(false);
    };

    return (
        <div className={styles.root}>
            <div className={styles.label}>Location</div>
            <ClickAwayListener
                disabled={disabled}
                onClickAway={() => setOpen(false)}
            >
                <div className={styles.fieldWrap}>
                    <div
                        className={clsx(styles.field, {
                            [styles.fieldOpen]: open,
                            [styles.fieldDisabled]: disabled
                        })}
                    >
                        <button
                            id="booking_select_location"
                            type="button"
                            className={styles.trigger}
                            disabled={disabled}
                            aria-expanded={open}
                            aria-haspopup="listbox"
                            onClick={() => !disabled && setOpen(current => !current)}
                        >
                            <span className={clsx(styles.triggerLabel, { [styles.placeholder]: open || !selected })}>
                                {open || !selected ? 'Select a Location' : selected.name}
                            </span>
                            <FontAwesomeIcon
                                icon={faChevronDown}
                                className={clsx(styles.chevron, { [styles.chevronOpen]: open })}
                            />
                        </button>

                        {open && (
                            <ul
                                className={styles.options}
                                role="listbox"
                            >
                                {options.map(option => {
                                    const isSelected = option.id === value;

                                    return (
                                        <li
                                            key={option.id}
                                            id={`booking_option_location_${option.id}`}
                                            role="option"
                                            aria-selected={isSelected}
                                            className={clsx(styles.option, {
                                                [styles.optionSelected]: isSelected
                                            })}
                                            onClick={() => selectHandler(option.id)}
                                        >
                                            <span>{option.name}</span>
                                            <FontAwesomeIcon
                                                icon={faLocationDot}
                                                className={styles.pin}
                                            />
                                        </li>
                                    );
                                })}
                            </ul>
                        )}
                    </div>
                </div>
            </ClickAwayListener>
        </div>
    );
};

export default LocationSelector;
